import { useState } from "react";
import { Reveal } from "../../common/reveal";
import { FaLinkedin, FaEnvelope, FaGithub } from "react-icons/fa";

export const Contact = () => {
  const [form, setForm] = useState({ name: "", message: "" });
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const sendEmail = (e) => {
    e.preventDefault();
    setSubmitting(true);

    const subject = "I would like to hire you";
    const body = `Hi Tsheko,\n\nMy name is ${form.name}.\n\n${form.message}`;
    const mailtoLink = `mailto:tshekokutumela@gmail.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    window.open(mailtoLink, "_blank");
    setSubmitting(false);
    setForm({ name: "", message: "" });
  };

  return (
    <Reveal>
      <section id="contact" className="max-w-3xl mx-auto py-16 px-6 text-white relative rounded-3xl bg-white/5 backdrop-blur-md shadow-xl">
        <h1 className="text-4xl md:text-5xl font-extrabold mb-4 text-center bg-clip-text text-transparent bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500">Get in Touch</h1>
        <p className="text-center text-gray-400 mb-12">Drop me a line, give me a call, or send me a message by submitting the form below.</p>

        <form onSubmit={sendEmail} className="space-y-6">
          <input name="name" type="text" required value={form.name} onChange={handleChange} placeholder="Your Name" className="w-full rounded-xl border border-gray-500 bg-transparent p-4 text-black placeholder-gray-400 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 outline-none transition" />
          <textarea name="message" rows={5} required value={form.message} onChange={handleChange} placeholder="Your Message" className="w-full rounded-xl border border-gray-500 bg-transparent p-4 text-black placeholder-gray-400 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 outline-none transition" />
          <button type="submit" disabled={submitting} className="w-full bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 hover:from-purple-500 hover:to-indigo-500 text-white font-bold py-3 rounded-xl shadow-lg disabled:opacity-50 disabled:cursor-not-allowed transition-all">
            {submitting ? "Opening Mail Client..." : "Send Message"}
          </button>
        </form>

        <div className="mt-12 flex justify-center space-x-8 text-3xl text-gray-800">
          <a href="https://www.linkedin.com/in/tshekokutumela/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="hover:text-indigo-500 transition  transform hover:scale-110">
            <FaLinkedin />
          </a>
          <a href="mailto:tshekokutumela@gmail.com" target="_blank" rel="noopener noreferrer" aria-label="Email" className="hover:text-purple-500 transition transform hover:scale-110">
            <FaEnvelope />
          </a>
          <a href="https://github.com/Tsheko777" target="_blank" rel="noopener noreferrer" aria-label="GitHub" className="hover:text-pink-500 transition transform hover:scale-110">
            <FaGithub />
          </a>
        </div>
      </section>
    </Reveal>
  );
};
